/**
 * Global app footer — copyright + agency / infrastructure attribution.
 * Rendered at the bottom of the first-party console shells (Dashboard,
 * Admin, Reseller). Subtle by design so it never competes with page content.
 */
export default function AppFooter({ className = '' }) {
  return (
    <footer
      className={`border-t border-gray-100 px-4 sm:px-6 lg:px-8 py-4 text-center text-xs text-ink-400 ${className}`}
    >
      © {new Date().getFullYear()} RankOnAI, All Rights Reserved. Made with{' '}
      <span className="text-accent-red" aria-label="love">
        ❤️
      </span>{' '}
      by{' '}
      <a
        href="https://pixalab.ai/"
        target="_blank"
        rel="noreferrer"
        className="font-medium text-ink-500 hover:text-brand-600 transition-colors"
      >
        PixaLab
      </a>{' '}
      | Powered by{' '}
      <a
        href="https://pixelnx.com/"
        target="_blank"
        rel="noreferrer"
        className="font-medium text-ink-500 hover:text-brand-600 transition-colors"
      >
        PixelNX
      </a>
      .
    </footer>
  );
}
